import { render } from "./quoteModel.vue?vue&type=template&id=2b57e194&scoped=true"
import script from "./quoteModel.vue?vue&type=script&lang=js"
export * from "./quoteModel.vue?vue&type=script&lang=js"

import "./quoteModel.vue?vue&type=style&index=0&id=2b57e194&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b57e194"]])

export default __exports__